import { DATE_PICKER_FORMATE, INVALID_DATE_MESSAGE_TRANSLATION, INVALID_DATE_RANGE_TRANSLATION, MAX_DRILL_DOWN_DAYS, USA_CANADA_COUNTRY } from '@shared/utils/layout-util';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { IFooterLink } from 'src/app/layout/models/layout-model';
import { RolePermissionService } from '@app/shared/services/role-permission/role-permission.service';
import { MAX_YEAR } from '@app/shared/utils/drill-down-util';
import { DatePipe } from '@angular/common';
import { ISelectedDate } from '@app/shared/models/header-search-model';


@Injectable({
  providedIn: 'root',
})
export class LayoutServiceService {
  datePipe = inject(DatePipe);
  public footerLinkList: WritableSignal<IFooterLink[][]> = signal<
    IFooterLink[][]
  >([]);
  constructor(private readonly rolePermission: RolePermissionService) { }

  extractDomain(): boolean {
    const country = this.rolePermission.getCountry()?.toLocaleLowerCase();
    if (!country) {
      return true;
    }

    return !USA_CANADA_COUNTRY.includes(country);
  }

  getFooterLinkDetails() {
    return this.footerLinkList;
  }

  getMinDrillDownDate(toDate: Date, maxDay: number) {
    let previousYear = new Date(toDate);
    previousYear.setHours(0, 0, 0, 0);
    previousYear.setFullYear(previousYear.getFullYear() - maxDay);
    return previousYear;
  }

  drillDownDateValidateion(date: Date | string) {

    if (date == null) {
      return { isValid: false, message: INVALID_DATE_MESSAGE_TRANSLATION };
    }

    if (!date) {
      return { isValid: true };
    }

    let selectedDate = new Date(date);

    if (!selectedDate?.getDate()) {
      return { isValid: false, message: INVALID_DATE_MESSAGE_TRANSLATION };
    }

    const maxDrillDate = new Date(this.getDate(1));
    maxDrillDate.setHours(0, 0, 0, 0);
    const minDrillDate = this.getMinDrillDownDate(maxDrillDate, MAX_YEAR);

    if (this.isBetweenDateRange(minDrillDate, maxDrillDate, selectedDate)) {
      return { isValid: true };
    }

    return { isValid: false, message: INVALID_DATE_RANGE_TRANSLATION }
  }

  public isBetweenDateRange(minDate: Date, maxDate: Date, selectedDate: Date) {
    return (selectedDate >= minDate && selectedDate <= maxDate);
  }

  drillDownDateComparison(fromDate: string, toDate: string) {
    let days = this.getDayBetweenTwoDate(fromDate, toDate);

    return days > MAX_DRILL_DOWN_DAYS;
  }

  getDayBetweenTwoDate(fromDate: string, toDate: string) {
    const startDate = new Date(fromDate);
    const endDate = new Date(toDate);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    const differentDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return differentDays + 1;
  }

  getDrillDownDateRange() {
    const maxDrillDate = new Date();
    const minDrillDate = this.getMinDrillDownDate(maxDrillDate, MAX_YEAR);
    const shortMaxDate = this.datePipe.transform(maxDrillDate, DATE_PICKER_FORMATE) as string;
    const shortMinDate = this.datePipe.transform(minDrillDate, DATE_PICKER_FORMATE) as string;

    return { fromDate: shortMinDate, toDate: shortMaxDate } as ISelectedDate;
  }


  getDate(dayDifferent: number) {
    let todayDate = new Date();
    let yesterdayDate = new Date(todayDate);
    yesterdayDate.setDate(yesterdayDate.getDate() - dayDifferent);
    return yesterdayDate;
  }
}
